export { DynamicScrollSizeDirective } from './lib/directives/dynamic-scroll-size.directive';
